var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".filled{fill:#a7a5a5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -90.998)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 90.998)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "filled",
    d: "M18.9,96.681C18.727,96.448,14.683,91,9.538,91S.274,96.448.1,96.681a.535.535,0,0,0,0,.635C.274,97.548,4.392,103,9.538,103s9.189-5.45,9.358-5.683A.535.535,0,0,0,18.9,96.681Zm-9.358,4.136a3.821,3.821,0,1,1,0-7.636,3.819,3.819,0,1,1,0,7.636Z",
    transform: "translate(0 -90.998)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.826 95.361)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "filled",
    d: "M211.715,211a1.638,1.638,0,1,0,0,3.273,1.636,1.636,0,1,0,0-3.273Z",
    transform: "translate(-210.006 -210.999)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeFilled);
export default __webpack_public_path__ + "static/media/eye-filled.4d0a815f9c889b87ff1d8931b83b5b1f.svg";
export { ForwardRef as ReactComponent };